import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteFolder = (folderId: number) => {
  return axios.delete(`/api/folders/${folderId}`);
};

type UseDeleteFolderOptions = {
  config?: MutationConfig<typeof deleteFolder>;
};

export const useDeleteFolder = ({ config }: UseDeleteFolderOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousFolders) {
        queryClient.setQueryData(['folders'], context.previousFolders);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['folders']);
      queryClient.invalidateQueries(['walls']);
    },
    ...config,
    mutationFn: deleteFolder,
  });
};
